<template>
  <div class="question-page">
    <div ref="questionBlock" class="question-block container">
      <div class="question-page__progress-bar-container">
        <ProgressBar :progress="checkProgress" />
      </div>
      <transition name="slide-fade" mode="out-in">
        <div :key="question.title" class="question-content" :class="{ 'drawer-padding': hasDrawer }">
          <div class="question-content__inside">
            <QuestionTitle
              :title="question.title"
              :subtitle="question.subtitle"
            />
            <component
              :is="componentOptions[question.type]"
              ref="component"
              :key="componentKey"
              v-model="answer"
              :data="question"
              :address-item-icon="addressItemIcon"
              :use-address-item-icon="whitelabelUseaddressItemIcon"
              :icon="whitelabelIcon"
              :icon-hover="whitelabelIconHover"
              :button-icon="whitelabelButtonIcon"
              :success-icon="whitelabelInputSuccessIcon"
              :error-icon="whitelabelInputErrorIcon"
              :use-input-left-icons="whitelabelUseInputLeftIcons"
              :icons="whitelabelServiceIcons"
              :use-white-selected-images="whitelabelSupplierUseWhiteLogos"
              :checkbox-image="whitelabelSupplierCheckboxImage"
              :show-radio-check-icon="whitelabelShowRadioCheckIcon"
              :tooltip-character="whitelabelTooltipCharacter"
              :use-location-pin-icon="whitelabelUseLocationPinIcon"
              :postcode-success-icon="whitelabelPostcodeSuccessIcon"
              :prepend-search-icon="whitelabelPrependSearchIcon"
              :placeholder-text="whitelabelPlaceholderText"
              :option="question.option"
              @autoprogress="next"
              @skippedQuestion="checkIfQSkipped"
            />
          </div>
          <div>
            <div
              v-if="question.inlineNextButton"
              class="next-btn-wrap text-right"
            >
              <CompactButton
                v-if="currentQuestionIndex !== 0"
                class="back-btn"
                :compact="true"
                @click="goBack"
              >
                <img class="back-btn__icon" src="@/assets/icons/arrow.svg">
              </CompactButton>
              <MicButton
                class="next-btn"
                :has-arrow="!whitelabelButtonIcon"
                :disabled="!hasAnswer"
                :shadow="false"
                @click="next()"
              >
                Next
                <img
                  v-if="whitelabelButtonIcon"
                  :src="
                    require(`@mic/frontend/assets/icons/${whitelabelButtonIcon}`)
                  "
                  alt="button icon"
                  class="next-btn__icon"
                >
              </MicButton>
            </div>
          </div>
        </div>
      </transition>
    </div>
    <AnswerProgressDrawer
      ref="progressDrawer"
      class="question-page__progress-draw"
      :question="question"
      :answer="answer"
      :button-icon="whitelabelButtonIcon"
      @next="next()"
    />
  </div>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from 'vuex'
import { QID_DEVICES, QID_LOCATIONS } from '@/constants/question-ids'
import ProgressBar from '@/components/progress/ProgressBar'
import MicButton from '@mic/frontend/buttons/MicButton'
import CompactButton from '@/components/ui/buttons/CompactButton'
import ChoiceBox from '@/components/question/inputs/ChoiceBox'
import SmartPostcodeLookup from '@mic/frontend/inputs/SmartPostcodeLookup'
import TradeList from '@mic/frontend/inputs/TradeList'
import QuestionTitle from '@/components/question/QuestionTitle'
import AnswerProgressDrawer from '@/components/progress/AnswerProgressDrawer'
import SupplierSelection from '@/components/question/inputs/SupplierSelection'
import CheckList from '@/components/question/inputs/CheckList'
import RadioList from '@/components/question/inputs/RadioList'
import VOIPSelection from '@/components/question/inputs/VOIPSelection'
import SummaryEdit from '@/components/question/inputs/SummaryEdit'
import ImageCounters from '@/components/question/inputs/ImageCounters'
import DesktopMobileApp from '@/components/question/inputs/DesktopMobileApp'
import QuestionData from 'questionData'
import Utag from '@/mixins/Utag'

const whitelabel = require('../../whitelabel.config')

export default {
  components: {
    ProgressBar,
    QuestionTitle,
    CompactButton,
    MicButton,
    AnswerProgressDrawer
  },
  mixins: [Utag],
  data () {
    return {
      answer: {},
      questionData: QuestionData,
      componentOptions: {
        box: ChoiceBox,
        postcode: SmartPostcodeLookup,
        tradelist: TradeList,
        supplier: SupplierSelection,
        checklist: CheckList,
        radiolist: RadioList,
        services: VOIPSelection,
        summary: SummaryEdit,
        DesktopMobileApp: DesktopMobileApp,
        imageCounters: ImageCounters
      },
      addressItemIcon: whitelabel[process.env.VUE_APP_BRAND].addressItemIcon,
      whitelabelIcon: whitelabel[process.env.VUE_APP_BRAND].searchButtonIcon,
      whitelabelIconHover:
        whitelabel[process.env.VUE_APP_BRAND].searchButtonIconHover,
      whitelabelButtonIcon: whitelabel[process.env.VUE_APP_BRAND].buttonIcon,
      whitelabelInputSuccessIcon:
        whitelabel[process.env.VUE_APP_BRAND].inputSuccessIcon,
      whitelabelInputErrorIcon:
        whitelabel[process.env.VUE_APP_BRAND].inputErrorIcon,
      whitelabelUseInputLeftIcons:
        whitelabel[process.env.VUE_APP_BRAND].useInputLeftIcons,
      whitelabelServiceIcons:
        whitelabel[process.env.VUE_APP_BRAND].serviceIcons,
      whitelabelSupplierUseWhiteLogos:
        whitelabel[process.env.VUE_APP_BRAND].supplierUseWhiteLogos,
      whitelabelSupplierCheckboxImage:
        whitelabel[process.env.VUE_APP_BRAND].supplierCheckboxImage,
      whitelabelShowRadioCheckIcon:
        whitelabel[process.env.VUE_APP_BRAND].showRadioCheckIcon,
      whitelabelTooltipCharacter:
        whitelabel[process.env.VUE_APP_BRAND].tooltipCharacter,
      whitelabelUtag: whitelabel[process.env.VUE_APP_BRAND].utag,
      whitelabelUseLocationPinIcon:
        whitelabel[process.env.VUE_APP_BRAND].useLocationPinIcon,
      whitelabelPostcodeSuccessIcon:
        whitelabel[process.env.VUE_APP_BRAND].postcodeSuccessIcon,
      whitelabelUseaddressItemIcon:
        whitelabel[process.env.VUE_APP_BRAND].useAddressItemIcon,
      whitelabelPrependSearchIcon:
        whitelabel[process.env.VUE_APP_BRAND].prependSearchIcon,
      whitelabelPlaceholderText:
        whitelabel[process.env.VUE_APP_BRAND].placeholderText
    }
  },
  computed: {
    ...mapGetters(['progress', 'getQuestions', 'getCurrentAnswer']),

    questions () {
      return this.getQuestions
    },
    question () {
      return this.questions.find((q) => q.slug === this.$route.params.slug)
    },
    checkProgress () {
      if (this.question.slug === 'summary') return 0.8
      return this.progress
    },
    hasDrawer () {
      return !this.question.inlineNextButton && !this.question.autoprogress
    },
    nextQuestion () {
      return this.questions[this.currentQuestionIndex + 1]
    },
    currentQuestionIndex () {
      return this.questions.findIndex(
        (q) => q.slug === this.$route.params.slug
      )
    },
    hasAnswer () {
      return this.answer && this.answer.result && this.answer.valid !== false
    },
    isLastQuestion () {
      return this.currentQuestionIndex === this.questions.length - 1
    },
    componentKey () {
      return this.$route.path
    }
  },

  watch: {
    $route (to, from) {
      this.fetchStoreAnswer()
    }
  },

  created () {
    this.fetchStoreAnswer()
    if (this.$route.query.postcode) {
      this.answer.postcode = this.$route.query.postcode
      this.$store.commit('UPDATE_POSTCODE_INPUT', this.answer.postcode)
      this.$store.dispatch('actionLoadAddresses', this.answer.postcode)
    }
  },

  mounted () {
    if (this.whitelabelUtag) {
      this.utag('QuoteStarted', 'QuoteStarted', 'QuoteStarted_NewQuote')
    }
  },
  methods: {
    ...mapMutations(['SET_ANSWER', 'SET_CURRENT_QUESTION']),
    ...mapActions(['set_skipped_question']),
    checkIfQSkipped (skipped, qId) {
      let payload = { 'addItem': null, 'questionId': qId }
      if (skipped) {
        // question skipped
        // add item to array
        payload['addItem'] = true
        this.set_skipped_question(payload)
      } else {
        payload['addItem'] = false
        this.set_skipped_question(payload)
      }
    },
    shouldSkipQuestion (questionIdName, result) {
      if (this.question.questionId === questionIdName && this.answer.result === result) return true
      return false
    },
    next (skipped) {
      this.SET_ANSWER({
        questionId: this.question.questionId,
        answer: this.answer
      })

      this.checkIfQSkipped(skipped, this.question.questionId)

      if (this.shouldSkipQuestion(QID_LOCATIONS, '0')) {
        // devices question skipped
        this.checkIfQSkipped(true, QID_DEVICES)
      }

      const route = this.isLastQuestion
        ? '/contact-details'
        : `/question/${this.nextQuestion.slug}`
      this.$router.push(route)
    },
    fetchStoreAnswer () {
      this.SET_CURRENT_QUESTION(this.question.questionId)
      this.$set(this, 'answer', this.getCurrentAnswer)
    },
    goBack () {
      this.$router.back()
    }
  }
}
</script>
<style lang='scss'>
  .question-page {
    &__progress-draw {
      .message {
        @media (min-width: 421px) {
          font-size: 18px;
          line-height: 22px;
        }
      }
      .title {
          @media (min-width: 421px) {
            font-size: 24px;
            line-height: 30px;
            margin-bottom: 14px;
          }
      }
    }
  }

</style>

<style lang="scss" scoped>

// animation
.slide-fade-enter-active {
  transition: all .3s ease;
}
.slide-fade-leave-active {
  transition: all .4s cubic-bezier(1.0, 0.5, 0.8, 1.0);
}
.slide-fade-enter, .slide-fade-leave-to {
  transform: translateX(10px);
  opacity: 0;
}

.question-page {
  padding-top: $spacing-64;
  overflow: visible;
  background-color: $question-background;
  min-height: 100%;
  position: relative;
  display: flex;
  flex-grow: 1;
  width: 672px;
  margin: 0 auto;

  @media (max-width: 719px) {
    padding-top: $spacing-24;
    width: 100%;
  }

   @media (max-width: 420px) {
    padding-top: $spacing-24;
    width: 320px;
  }

  &__progress-bar-container {
    margin: 26px auto 16px auto;
    height: 13px;
    position: relative;
    width: 288px;
    top: 0;
    overflow: visible;
    background-color: #fff;
    border-radius: $border-radius-large;

    @media (min-width: 720px) {
      height: 16px;
      margin: 33px auto 40px auto;
      width: 472px;
    }

      @media (min-width:421px) and (max-width:719px) {
        width: 340px;
    }
  }

  .progress-fill {
    width: 50%;
    position: absolute;
    left: 0;
    height: 100%;
    background-color: $progress-bar-fill;
    transition: width 0.6s;
    border-radius: $border-radius-large;
  }

  .question-content {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    padding-bottom: 105px;

    &__inside {
      margin-bottom: 30px;
    }

    &.drawer-padding {
      padding-bottom: $progress-drawer-height-desktop + $spacing-12;
    }

    @media (max-width: $screen-md) {
      flex-grow: 1;

      &.drawer-padding {
        padding-bottom: $progress-drawer-height-mobile;
      }
    }
  }

  .question-block {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    width: 640px;

   @media (min-width:421px) and (max-width:719px) {
        width: 362px;
    }
  }

  .next-btn-wrap {
    display: flex;
    justify-content: flex-end;
  }

  .next-btn {
    transition: -webkit-transform 0.2s ease-out;

    @media (max-width: 420px) {
      width: 96px;
      height: 42px;
      font-size: 14px;
    }

    &:active {
      background-color: #1370ff;
      color: white;
    }

    &:disabled {
      opacity: .2;
    }

    &:hover {
      top: 0;
      transform: translate3d(0, -4px, 0);
      box-shadow: 0px 0px 14px 0 rgba(0, 0, 0,  0.1%);

    }
    &__icon {
        margin-top: 2px;
        margin-left: $spacing-8;
    }
  }

  .back-btn {
    margin-right: auto;

    @media(min-width: 421px) {
      width: 56px;
      height: 56px;
    }

    &__icon {
        @media (max-width: 720px) {
          width: 65px;
        }
    }
  }
}
</style>
